import PropTypes from "prop-types";
import styled from "styled-components";

function formatNumber(num) {
    if (num % 1 !== 0) {
        return num.toFixed(2);
    } else {
        return num;
    }
}
function nearestInteger(num) {
    return Math.round(num);
}
const getDynamicGradient = (normalColorVar) => {
    const lightColorVar = normalColorVar.replace('-normal)', '-light)');
    return `linear-gradient(
    90deg, 
    var(--q3-surface-default_0) 0%,
    ${lightColorVar} 100%,
    ${normalColorVar} 100%
  )`;
};
const StatCell = (props) => {
    const {
        color,
        top,
        bottom,
        showPercentage,
        textAppend = "",
        themedText = false,
    } = props;
    const percentage = (top / bottom) * 100;

    const getPercentage = () => {
        // if percentage is NaN, return 0
        if (isNaN(percentage)) return 0;
        return nearestInteger(formatNumber(percentage)) + "%";
    };

    return (
        <CellContainer
            style={{
                cursor: "pointer",
            }}
        >
            <Cell progress={percentage} {...props}>
                {showPercentage ? (
                    <Cell.UpperText color={color} themedText={themedText}>
                        {getPercentage()}
                    </Cell.UpperText>
                ) : (
                    <>
                        {bottom == 0 ? (
                            <Cell.UpperText color={color}>{formatNumber(top)}</Cell.UpperText>
                        ) : (
                            <>
                                <Cell.UpperText color={color}>
                                    {nearestInteger(top)}
                                </Cell.UpperText>
                                /
                                <Cell.BottomText className="text-muted">
                                    {bottom}
                                </Cell.BottomText>
                            </>
                        )}
                        {textAppend && (
                            <Cell.BottomText className="text-muted">
                                {textAppend}
                            </Cell.BottomText>
                        )}
                    </>
                )}
            </Cell>
        </CellContainer>
    );
};
export default StatCell;

StatCell.propTypes = {
    color: PropTypes.string,
    top: PropTypes.number,
    bottom: PropTypes.number,
    questions: PropTypes.array,
};

StatCell.defaultProps = {
    color: "orange",
    top: 0,
    bottom: 0,
    questions: [],
};

const CellContainer = styled.div`
  border: 1px solid var(--blue-gray-200-light);
  border-bottom: 0;
  border-right: 0;
  border-top: 0;

  &:last-child {
    // border-right: 1px solid var(--blue-gray-200-light);
  }
`;

let Cell = styled.div`
  width: ${(props) => (props.progress > 0 ? props.progress : 0)}%;
  background-color: ${(props) => props.color};
    background: ${(props) => getDynamicGradient(props.color)};
  padding: 20px 0px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
  border-right: 2px solid ${(props) => props.color};
  transition: all 0.5s ease-in-out;
`;

Cell.UpperText = styled.span`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 125%;
  color: ${({ color, themedText, theme }) =>
        themedText ? (theme.isDark ? "rgb(148, 164, 184)" : color) : color};
  padding-left: 20px;
`;

Cell.BottomText = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
  color: ${(props) => props.color || "inherit"};
`;
